import React, { PureComponent } from 'react';
import { Button, Grid, Divider, Image } from 'semantic-ui-react';

import Images from '../../../assets/Images';
import './AdBuilderSelector.css';

class AdBuilderSelector extends PureComponent {
  render() {
    return (
      <div>
        <Button onClick={this.props.searchPage} size="small" color="grey">
          Back
        </Button>
        <Divider hidden />
        <div className="ad-selector-grid-container">
          <Grid className="ad-selector-grid">
            <Grid.Row columns={3}>
              <Grid.Column>
                <div className="ad-selector-container">
                  <a
                    role="button"
                    tabIndex={0}
                    className="ad-selector-link"
                    onClick={() => this.props.createAd('Canvas')}
                  >
                    <Image
                      className="ad-selector-image"
                      src={Images.canvasType}
                    />
                  </a>
                </div>
              </Grid.Column>
              <Grid.Column>
                <div className="ad-selector-container">
                  <a
                    role="button"
                    tabIndex={0}
                    className="ad-selector-link"
                    onClick={() => this.props.createAd('Video')}
                  >
                    <Image
                      className="ad-selector-image"
                      src={Images.videoType}
                    />
                  </a>
                </div>
              </Grid.Column>
              <Grid.Column>
                <div className="ad-selector-container">
                  <a
                    role="button"
                    tabIndex={0}
                    className="ad-selector-link"
                    onClick={() => this.props.createAd('Collection')}
                  >
                    <Image
                      className="ad-selector-image"
                      src={Images.collectionType}
                    />
                  </a>
                </div>
              </Grid.Column>
            </Grid.Row>
            <Grid.Row columns={3}>
              <Grid.Column>
                <div className="ad-selector-container">
                  <a
                    role="button"
                    tabIndex={0}
                    className="ad-selector-link"
                    onClick={() => this.props.createAd('Carousel')}
                  >
                    <Image
                      className="ad-selector-image"
                      src={Images.carouselType}
                    />
                  </a>
                </div>
              </Grid.Column>
              <Grid.Column>
                <div className="ad-selector-container">
                  <div className="ad-selector-container">
                    <a
                      role="button"
                      tabIndex={0}
                      className="ad-selector-link"
                      onClick={() => this.props.createAd('DAA')}
                    >
                      <Image
                        className="ad-selector-image"
                        src={Images.daaType}
                      />
                    </a>
                  </div>
                </div>
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </div>
      </div>
    );
  }
}

export default AdBuilderSelector;



// WEBPACK FOOTER //
// ./src/screens/PackageBuilder/AdLibrary/AdBuilderSelector.js